module.exports = __webpack_public_path__ + "static/google-188616b3b2db158c7e0940f8c09a73fb.jpg";